import {
  addMessage,
  createConversation,
  findConversations,
  getConversation,
  getMessagesForConversation,
  joinConversation,
  updateConversation,
} from '../../services/api/miles/notes';

export class ConversationService {
  public static async createConversation(
    data: MilesPosNotesIntegrationService.Components.Schemas.CreateConversationRequest
  ): Promise<MilesPosNotesIntegrationService.Components.Schemas.Conversation> {
    return createConversation(data);
  }

  public static async getConversation(
    conversationId: string
  ): Promise<MilesPosNotesIntegrationService.Components.Schemas.GetConversationByIdResponse> {
    return getConversation(conversationId);
  }

  public static async updateConversation(
    conversationId: string,
    data: MilesPosNotesIntegrationService.Components.Schemas.UpdateConversationRequest
  ): Promise<MilesPosNotesIntegrationService.Components.Schemas.Conversation> {
    return updateConversation(conversationId, data);
  }

  public static async getMessagesForConversation(
    conversationId: string,
    since?: string
  ): Promise<MilesPosNotesIntegrationService.Components.Schemas.ConversationMessagesResponse> {
    return getMessagesForConversation(conversationId, since);
  }

  public static async addMessage(
    conversationId: string,
    data: MilesPosNotesIntegrationService.Components.Schemas.CreateMessageRequest
  ): Promise<MilesPosNotesIntegrationService.Components.Schemas.CreateMessageResponse> {
    return addMessage(conversationId, data);
  }

  public static async findConversations(
    data: MilesPosNotesIntegrationService.Components.Schemas.FindConversationsRequest
  ): Promise<MilesPosNotesIntegrationService.Components.Schemas.FindConversationsResponse> {
    return findConversations(data);
  }

  public static async joinConversation(
    conversationId: string
  ): Promise<MilesPosNotesIntegrationService.Components.Schemas.JoinConversationResponse> {
    return joinConversation(conversationId);
  }
}
